import ExternalLink from '@components/ExternalLink/ExternalLink';
import * as styles from '@layouts/HomeLayout.module.scss';
import * as React from 'react';
export default {
  ExternalLink,
  styles,
  React
};